/*
  Bordas suaves nas listas que rolam para o lado (estilo em assets/unend-bordas.css).
  Marca em data-unend-borda o lado onde uma peca esta cortada pela borda da lista: "inicio", "fim" ou "inicio fim".
  Assim o esmaecimento aparece quando ha corte (durante a troca de pecas no carrossel ou com a proxima peca
  aparecendo pela metade no celular) e some quando as pecas param alinhadas. Lista que rola sem corte no momento
  fica com a marca vazia (para o esmaecimento entrar e sair aos poucos); lista que cabe inteira fica sem marca.
  A galeria de fotos do produto fica de fora. Acompanha rolagem, mudanca de tamanho e listas que entram depois.
*/
(() => {
  const SELETOR = '.scroll-area, .unend-upsell__list, .unend-cur__cards, .unend-quick-filters__chips, .unend-vender__steps';
  const FORA = '.product-gallery__carousel';
  const FOLGA = 4;
  const preparadas = new WeakSet();

  /* Pecas da lista: os filhos diretos; se houver um unico filho mais largo que a lista (trilho), os filhos dele */
  const pecasDe = (lista, larguraLista) => {
    let pecas = Array.from(lista.children);
    if (pecas.length === 1 && pecas[0].getBoundingClientRect().width > larguraLista + FOLGA) {
      pecas = Array.from(pecas[0].children);
    }
    return pecas;
  };

  const medir = (lista) => {
    if (lista.scrollWidth - lista.clientWidth <= 2) {
      lista.removeAttribute('data-unend-borda');
      return;
    }
    const caixa = lista.getBoundingClientRect();
    let cortaInicio = false;
    let cortaFim = false;

    for (const peca of pecasDe(lista, caixa.width)) {
      const r = peca.getBoundingClientRect();
      if (!r.width) continue;
      if (r.left < caixa.left - FOLGA && r.right > caixa.left + FOLGA) cortaInicio = true;
      if (r.left < caixa.right - FOLGA && r.right > caixa.right + FOLGA) cortaFim = true;
      if (cortaInicio && cortaFim) break;
    }

    const lados = [];
    if (cortaInicio) lados.push('inicio');
    if (cortaFim) lados.push('fim');
    const valor = lados.join(' ');
    if (lista.getAttribute('data-unend-borda') !== valor) {
      lista.setAttribute('data-unend-borda', valor);
    }
  };

  const observador = 'ResizeObserver' in window
    ? new ResizeObserver((entradas) => entradas.forEach((entrada) => medir(entrada.target)))
    : null;

  const preparar = (lista) => {
    if (preparadas.has(lista) || lista.matches(FORA)) return;
    preparadas.add(lista);
    let agendado = false;
    const agendar = () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => {
        agendado = false;
        medir(lista);
      });
    };
    lista.addEventListener('scroll', agendar, { passive: true });
    lista.addEventListener('scrollend', agendar, { passive: true });
    if (observador) observador.observe(lista);
    medir(lista);
  };

  const varrer = (raiz) => {
    if (raiz.matches && raiz.matches(SELETOR)) preparar(raiz);
    raiz.querySelectorAll(SELETOR).forEach(preparar);
  };

  varrer(document);
  window.addEventListener('load', () => varrer(document));

  new MutationObserver((mudancas) => {
    mudancas.forEach((mudanca) => {
      mudanca.addedNodes.forEach((no) => {
        if (no.nodeType === 1) varrer(no);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
